export const CONTEST_SET_PAGES_IN_BRACKET = 'SET_CONTEST_ENTRY_IDS';

export function setContestPages(bracket, pages) {
  return {
    type: CONTEST_SET_PAGES_IN_BRACKET,
    data: {
      bracket,
      pages
    }
  };
}
